import { useMemo } from 'react';
import { useGetMappingBreakdownQuery } from '@/entities/dashboard/mapping';
import type { DataLayer } from '../lib/location-popup.utils';
import { getBreakdownType, calculateWeekNumber, formatPieChartData } from '../lib/location-popup.utils';
import { useProjectSiteParams } from '@/shared/lib';

interface UseLocationBreakdownParams {
  locationId: string;
  dataLayer: DataLayer;
  currentWeek: number;
  hasData: boolean;
}

export function useLocationBreakdown({ locationId, dataLayer, currentWeek, hasData }: UseLocationBreakdownParams) {
  const { projectId, siteId } = useProjectSiteParams();
  const weekNo = calculateWeekNumber(currentWeek);
  const breakdownType = getBreakdownType(dataLayer);

  const { data: breakdownData, isFetching } = useGetMappingBreakdownQuery(
    { locationId, type: breakdownType, weekNo, projectId, siteId },
    {
      skip: !hasData,
      refetchOnMountOrArgChange: true
    }
  );

  const pieData = useMemo(() => {
    return formatPieChartData(breakdownData);
  }, [breakdownData]);

  return {
    pieData,
    isLoading: isFetching,
    breakdownType,
    weekNo
  };
}
